import { Redirect } from 'wouter';
import { useCurrentUser, redirectIsValid } from './helpers';
import { EXIT } from '~/components/analytics/constants';
import track from '~/components/analytics/track';
import {
  getRedirectUrl,
  clearAllContext,
  getNextPage,
  clearNextPage,
} from '~/components/context';
import { PRODUCTS } from '~/routes/paths';
import { getWindow } from '~/utils/window';

const Exit = () => {
  const user = useCurrentUser();
  const redirectUri = getRedirectUrl();
  const canRedirect = redirectIsValid(redirectUri, user);
  if (canRedirect && typeof redirectUri === 'string') {
    track(EXIT, { redirectUri });
    clearAllContext();
    getWindow().location.replace(redirectUri);
  } else {
    const nextPage = getNextPage() || PRODUCTS;
    clearNextPage();
    return <Redirect to={nextPage} />;
  }
  return null;
};

export default Exit;
